<template>
	<div class="voucher-table bg-white-color">
		<table class="header" cellspacing="0" cellpadding="0">
			<tbody>
			<tr class="bg-white-color">
				<td style="width: 208px; font-weight: bold;">
					摘要
					<i class="fa fa-list-ul summary-manage" v-tooltip content="常用摘要 / 一键录入" @click="openSummaryModal"></i>
				</td>
				<td style="width: 308px; font-weight: bold;">会计科目</td>
				<td>
					<div style="font-weight: bold;">
						借方金额
					</div>
					<div class="moneyUint">
						<span>亿</span> <span>千</span> <span>百</span> <span>十</span> <span>万</span> <span>千</span>
						<span>百</span> <span>十</span> <span>元</span> <span>角</span> <span class="last">分</span>
					</div>
				</td>
				<td class="tdLast">
					<div style="font-weight: bold;">
						贷方金额
					</div>
					<div class="moneyUint">
						<span>亿</span> <span>千</span> <span>百</span> <span>十</span> <span>万</span> <span>千</span>
						<span>百</span> <span>十</span> <span>元</span> <span>角</span> <span class="last">分</span>
					</div>
				</td>
			</tr>
			</tbody>
		</table>
		<table class="body" cellspacing="0" cellpadding="0">
			<tbody>
			<tr class="trDetails" v-for="(d,i) in details" :key="i" :data-idx="i">
				<td class="tdZhaoyao tdInput">
					<div class="display" v-if="!d.zyEdit" @click="doEdit(d,'zy',i)">{{d.data.summary}}</div>
					<DropdownCustom v-show="d.zyEdit" ref="zyDropdown" trigger="manual" :toggle-icon="false" style="width: 100%" equalWidth @hide="endEdit(d,'zy',i)">
						<textarea class="h-input edit" data-type="zy" :data-index="i" :id="'zy'+i" @input="zyInput"></textarea>
						<template slot="content">
							<div style="height: 180px;overflow-y: scroll;">
								<ul class="summary" :id="`summary${i}`">
									<li class="summary-item" :data-index="idx" :class="{'summary-item-select':(idx===0&&zyFiler)}" v-for="(s,idx) in summaryData" @click="chooseSummary(d,s.name,i)">
										{{s.name}}
									</li>
								</ul>
							</div>
						</template>
					</DropdownCustom>
				</td>
				<td class="tdKemu tdInput">
					<div class="display" v-if="!d.kmEdit" @click="doEdit(d,'km',i)">
						{{d.data.subjectName||''}}{{d.data.auxiliaryTitle||''}}
					</div>
					<div class="yue" v-if="balanceList[d.data.subjectId]">余额：
						<span :class="{'red-color':balanceList[d.data.subjectId]<0}">{{balanceList[d.data.subjectId] | numFormat}}</span>
					</div>
					<Row v-if="isForeign" @click.stop="" class="fcm" type="flex" :space-x="10">
					<Cell>原币:</Cell>
					<Cell>
						<span @click.stop="showInput" class="text-hover">{{d.data.originalAmount||0}}</span>
						<input class="fcmInput" @blur.stop="fcmBlur($event,d.data)" style="display: none;" type="number" step="0.01" v-model="d.data.originalAmount">
					</Cell>
				</Row>
				<Row v-if="d.data.unit || d.data.num" @click.stop="" class="num" type="flex" :space-x="10">
						<Cell>数量:</Cell>
						<Cell>
							<span @click.stop="showInput" class="text-hover">{{d.data.num||0}}</span>
							<input class="numInput" @blur.stop="hideInput($event,d.data)" @click="" style="display: none;" v-model="d.data.num" @click.stop="" v-width="40">
						</Cell>
						<Cell>单价:</Cell>
						<Cell>
							<span @click.stop="showInput" class="text-hover">{{d.data.price||0}}</span>
							<input class="numInput" @blur.stop="hideInput($event,d.data)" style="display: none;" v-model="d.data.price" @click.stop="" v-width="40">
						</Cell>
					</Row>
					<DropdownCustom v-show="d.kmEdit" ref="kmDropdown" trigger="manual" :toggle-icon="false" style="width: 100%" equalWidth @hide="endEdit(d,'km',i)">
						<textarea class="h-input edit" data-type="km" :data-index="i" :id="'km'+i" @input="kmInput"></textarea>
						<template slot="content">
							<div style="height: 180px;overflow-y: scroll;" v-if="!d.auxiliary">
								<ul class="subjects" :id="`subjects${i}`">
									<li class="subjects-item" :data-index="idx" :class="{'subjects-item-select':(idx===0&&kmFiler)}" v-for="(s,idx) in subjectData" @click="chooseSubject(d,s,i)">
										{{s.code}} {{s.name}}
									</li>
								</ul>
							</div>
							<div v-else class="auxiliary padding">
								<Row v-if="auxiliaryAccounting[i]" v-for="item in auxiliaryAccounting[i]" type="flex" :space="10" :key="item.id">
									<Cell :flex="1" class="label">{{item.name}}</Cell>
									<Cell v-width="180">
										<Select v-model="d.data[item.id]" v-if="auxiliaryAccountingData[d.data.subjectId]" type="object" className="auxiliary" keyName="id" titleName="name" :datas="auxiliaryAccountingData[d.data.subjectId][item.id]" :filterable="true"></Select>
									</Cell>
								</Row>
								<div class="text-center margin-top">
									<Button color="primary" @click="fillAuxiliary(d,auxiliaryAccountingData[d.data.subjectId],i)">确认</Button>
								</div>
							</div>
						</template>
					</DropdownCustom>
				</td>
				<td class="tdJieFang tdInput">
					<div v-if="!d.jfEdit" class="display displayMoney" :class="{'red-color':d.data.debitAmount<0}" @click="doEdit(d,'jf',i)">
						<span @click.stop="doEdit(d,'jf',i)">{{d.data.debitAmount|formatMoney}}</span>
					</div>
					<DropdownCustom v-show="d.jfEdit" ref="jfDropdown" placement="top" trigger="manual" :toggle-icon="false" style="width: 100%" equalWidth @hide="endEdit(d,'jf',i)">
						<input max="999999999" min="-999999999" type="number" class="h-input jf edit" data-type="jf" :data-index="i" :id="'jf'+i" v-model="d.data.debitAmount">
						<template slot="content">
							<div class="hoverNum">{{d.data.debitAmount|numFormat}}</div>
						</template>
					</DropdownCustom>
				</td>
				<td class="tdLast tdDaiFang tdInput">
					<div v-if="!d.dfEdit" class="display displayMoney" :class="{'red-color':d.data.creditAmount<0}" @click="doEdit(d,'df',i)">
						<span @click.stop="doEdit(d,'df',i)">{{d.data.creditAmount|formatMoney}}</span>
					</div>
					<DropdownCustom v-show="d.dfEdit" ref="dfDropdown" placement="top" trigger="manual" :toggle-icon="false" style="width: 100%" equalWidth @hide="endEdit(d,'df',i)">
						<input max="999999999" min="-999999999" :data-index="i" data-type="df" class="h-input df edit" :id="'df'+i" v-model="d.data.creditAmount" step="">
						<template slot="content">
							<div class="hoverNum">{{d.data.creditAmount|numFormat}}</div>
						</template>
					</DropdownCustom>
				</td>
			</tr>
			<tr class="trDetails total">
				<td colspan="2" class="spTotal padding-left">
					合计: {{jfTotal|dxMoney}}
				</td>
				<td style="width: 220px;">
					<div class="display displayMoney">
						<span class="spTotalDebit">{{jfTotal|formatMoney}}</span>
					</div>
				</td>
				<td class="tdLast" style="width: 220px;">
					<div class="display displayMoney">
						<span class="spTotalCredit">{{dfTotal|formatMoney}}</span>
					</div>
				</td>
			</tr>
			<tr class="trDetails zone-total" v-if="showZoneTotal">
				<td colspan="4" class="padding-left zone-info">
					平行记账：
					<span :class="{'red-color': !finBalanced}">财务会计 借 {{finJfTotal|formatMoney}} 贷 {{finDfTotal|formatMoney}}{{finBalanced ? '（平衡）' : '（不平衡）'}}</span>
					<span class="zone-sep">｜</span>
					<span :class="{'red-color': !budgetBalanced}">预算会计 借 {{budgetJfTotal|formatMoney}} 贷 {{budgetDfTotal|formatMoney}}{{budgetBalanced ? '（平衡）' : '（不平衡）'}}</span>
				</td>
			</tr>
			</tbody>
		</table>
		<i class="action fa fa-times-circle" @click="removeItem()"></i>
		<i class="action fa fa-plus-circle" @click="addItem()"></i>
		<Modal v-model="summaryModal.show" :closeOnMask="true">
			<div slot="header">常 用 摘 要</div>
			<div class="summary-modal">
				<div class="block">
					<div class="block-title">一键录入摘要</div>
					<Row type="flex" :space-x="10">
						<Cell :flex="1"><input type="text" class="h-input" v-model="summaryModal.fillText" placeholder="输入摘要内容后选择录入方式"/></Cell>
						<Cell><Button size="s" @click="fillSummary('blank')">填入空白行</Button></Cell>
						<Cell><Button size="s" @click="fillSummary('all')">覆盖全部行</Button></Cell>
						<Cell><Button size="s" @click="fillSummary('checked')" :disabled="!summaryModal.checkedRows.length">覆盖勾选行</Button></Cell>
					</Row>
					<div class="row-checks" v-if="contentRows.length">
						<label v-for="r in contentRows" :key="r.idx">
							<input type="checkbox" :value="r.idx" v-model="summaryModal.checkedRows"/> 第{{r.idx + 1}}行 <span class="dark4-color">{{r.summary || '(无摘要)'}}</span>
						</label>
					</div>
				</div>
				<div class="block">
					<div class="block-title">常用摘要管理</div>
					<Row type="flex" :space-x="10">
						<Cell :flex="1"><input type="text" class="h-input" v-model="summaryModal.newContent" placeholder="请输入摘要，回车新增" @keyup.enter="addSummaryTemplate"/></Cell>
						<Cell><Button size="s" color="primary" @click="addSummaryTemplate">新增摘要</Button></Cell>
					</Row>
					<div class="margin-top"><input type="text" class="h-input" v-model="summaryModal.keyword" placeholder="请输入摘要检索"/></div>
					<ul class="tpl-list">
						<li v-for="t in filteredTemplates" :key="t.id">
							<span class="tpl-content" @click="summaryModal.fillText = t.content">{{t.content}}</span>
							<i class="fa fa-trash-o" v-tooltip content="删除" @click="removeSummaryTemplate(t)"></i>
						</li>
						<li v-if="!filteredTemplates.length" class="empty">暂无常用摘要，可在上方新增</li>
					</ul>
				</div>
			</div>
			<div slot="footer"><Button @click="summaryModal.show = false">关闭</Button></div>
		</Modal>
	</div>
</template>

<script>
	import jQuery from 'jquery';
	import Decimal from 'decimal.js';
	import Pinyin from 'chinese-to-pinyin';
	import {mapState} from 'vuex';

	const BUDGET_TYPES = ['预算收入', '预算支出', '预算结余'];

	const detail = {
		zyEdit: false,
		kmEdit: false,
		jfEdit: false,
		dfEdit: false,
		auxiliary: false,
		data: {summary: '', subjectName: ''}
	};

	const nextTag = {
		zy: 'km',
		km: 'jf',
		jf: 'df'
	};

	const FormatNum = function (num, digit = 2) {
		return Decimal(num).toFixed(digit);
	};

	const ToPy = (name) => {
		let pyArr = [];
		name.split("").forEach(w => {
			w = w.trim();
			if (w) {
				if (/[\u4e00-\u9fa5]/.test(w)) {
					let py = Pinyin(w, {removeTone: true, keepRest: true}).trim();
					pyArr.push(py.substring(0, 1));
				} else {
					pyArr.push(w);
				}
			}
		});

		return pyArr.join("");
	};

	export default {
		name: "VoucherTable",
		props: {
			value: Object,
			currencyId: Number,
			exchangeRate: Number
		},
		data() {
			return {
				details: [{zyEdit: false, kmEdit: false, jfEdit: false, dfEdit: false, auxiliary: false, data: {summary: ''}}, {zyEdit: false, kmEdit: false, jfEdit: false, dfEdit: false, auxiliary: false, data: {summary: ''}}, {zyEdit: false, kmEdit: false, jfEdit: false, dfEdit: false, auxiliary: false, data: {summary: ''}}, {zyEdit: false, kmEdit: false, jfEdit: false, dfEdit: false, auxiliary: false, data: {summary: ''}}],
				hoverIdx: -1,
				voucherSelect: [],
				summarySelect: [],
				auxiliaryAccounting: [],
				zyFiler: "",
				kmFiler: "",
				zaiYao: [],
				balanceList: {},
				initBalanceList: {},
				auxiliaryAccountingData: {},
				currentEdit: null,
				jfTotal: 0,
				dfTotal: 0,
				budgetJfTotal: 0,
				budgetDfTotal: 0,
				hasBudgetEntry: false,
				summaryModal: {show: false, keyword: '', fillText: '', newContent: '', checkedRows: []},
				summaryTemplates: []
			}
		},
		computed: {
			...mapState(['currentAccountSets']),
			isGovernment() {
				return this.currentAccountSets && Number(this.currentAccountSets.accountingStandards) === 7;
			},
			finJfTotal() {
				return FormatNum(Decimal(this.jfTotal || 0).minus(this.budgetJfTotal || 0).toNumber());
			},
			finDfTotal() {
				return FormatNum(Decimal(this.dfTotal || 0).minus(this.budgetDfTotal || 0).toNumber());
			},
			budgetBalanced() {
				return Number(this.budgetJfTotal) === Number(this.budgetDfTotal);
			},
			finBalanced() {
				return Number(this.finJfTotal) === Number(this.finDfTotal);
			},
			showZoneTotal() {
				return this.isGovernment && this.hasBudgetEntry;
			},
			isForeign() {
				return !!this.currencyId;
			},
			filteredTemplates() {
				if (this.summaryModal.keyword) {
					return this.summaryTemplates.filter(t => t.content.indexOf(this.summaryModal.keyword) !== -1);
				}
				return this.summaryTemplates;
			},
			contentRows() {
				return this.details.map((d, idx) => ({idx, data: d.data, summary: d.data.summary}))
					.filter(r => r.data.subjectId || r.data.debitAmount || r.data.creditAmount || r.data.summary);
			},
			subjectData() {
				if (this.kmFiler) {
					return this.voucherSelect.filter(value => {
						return (value.code || '').indexOf(this.kmFiler) !== -1 || (value.name || '').indexOf(this.kmFiler) !== -1 || (value.mnemonicCode || '').indexOf(this.kmFiler) !== -1;
					});
				}
				return this.voucherSelect;
			},
			summaryData() {
				if (this.zyFiler) {
					return this.summarySelect.filter(value => {
						return value.name.indexOf(this.zyFiler) !== -1 || value.mnemonicCode.indexOf(this.zyFiler) !== -1;
					});
				}
				return this.summarySelect;
			},
			voucherItems() {
				return this.details.map(value => value.data).filter(value => {
					return value.subjectId || value.summary || value.debitAmount || value.creditAmount;
				}).map(value => {
					let keys = Object.keys(value).filter(key => !isNaN(Number(key))), auxiliary = [];
					if (keys.length) {
						keys.forEach(key => {
							auxiliary.push(value[key]);
						})
					}

					return {
						auxiliary,
						debitAmount: value.debitAmount,
						creditAmount: value.creditAmount,
						subjectId: value.subjectId,
						direction: value.direction,
						subjectName: value.subjectName || '',
						subjectCode: value.subjectCode || '',
						auxiliaryTitle: value.auxiliaryTitle || '',
						summary: value.summary ? value.summary.trim().replace(/\s+/g, '') : '',
						num: value.num,
						price: value.price,
						originalAmount: value.originalAmount,
						currencyId: this.currencyId || null
					}
				});
			}
		},
		methods: {
			kmInput(e) {
				this.kmFiler = e.target.value;
				this.$set(this.details[this.currentEdit.idx], 'auxiliary', false);
			},
			zyInput(e) {
				this.zyFiler = e.target.value;
				this.$set(this.details[this.currentEdit.idx].data, 'summary', e.target.value);
			},
			removeItem() {
				if (this.details.length > 4) {
					this.details.splice(this.hoverIdx, 1);
				} else {
					this.$set(this.details[this.hoverIdx], 'data', {});
				}
			},
			addItem(idx) {
				this.details.splice(idx ? idx : Math.max((this.hoverIdx), 0), 0, {
					zyEdit: false,
					kmEdit: false,
					jfEdit: false,
					dfEdit: false,
					auxiliary: false,
					data: {summary: '', subjectName: ''}
				});
				this.$nextTick(() => {
					this.bindEnterTabKeydownEvt();
				})
			},
			doEdit(row, type, idx) {
				if (this.currentEdit) {
					this.endEdit(this.currentEdit.row, this.currentEdit.type, this.currentEdit.idx)
				}
				this.$nextTick(() => {
					this.$set(row, type + 'Edit', true);
					this.currentEdit = {row, type, idx};

					this.$nextTick(() => {
						let keMuTxt = jQuery(`textarea#${type}${idx}`);
						keMuTxt.focus().select();
						if (type === 'km') {
							keMuTxt.val(row.data.subjectName);
							if (row.data.subject && row.data.subject.auxiliaryAccounting) {
								this.$set(this.details[idx], 'auxiliary', true);
							}
						}
						jQuery(".h-input", `#${type}${idx}`).focus().select();
						jQuery(`#${type}${idx}`).focus().select();
						this.$refs[`${type}Dropdown`][idx].show();
					});
				});
			},
			endEdit(row, type, idx, doNext = false) {
				if (row[type + 'Edit']) {
					this.$set(row, type + 'Edit', false);
					this.kmFiler = "";
					let debitAmount = Number(row.data.debitAmount);
					let creditAmount = Number(row.data.creditAmount);
					switch (type) {
						case 'jf':
							if (!isNaN(debitAmount) && !isNaN(creditAmount) && debitAmount) {
								this.$set(row.data, 'creditAmount', '');
							}
							this.calculateBalance(row.data.subjectId);
							break;
						case 'df':
							if (!isNaN(debitAmount) && !isNaN(creditAmount) && creditAmount) {
								this.$set(row.data, 'debitAmount', '');
							}
							break;
					}

					this.calculateBalance(row.data.subjectId);

					//如果有单位则需要计算单价
					if (row.data.unit && row.data.num > 0) {
						let money = debitAmount || creditAmount;
						this.$set(this.details[idx].data, 'price', Number((money / row.data.num).toFixed(2)));
					}

					let dropdown = this.$refs[`${type}Dropdown`][idx];
					dropdown && dropdown.hide();
					//关闭辅助项输入
					this.$set(this.details[idx], 'auxiliary', false);

					if (doNext) {
						if (type === 'jf' && row.data.debitAmount) {
							this.lastNext(idx);
						} else if (type !== 'df') {
							this.doEdit(row, nextTag[type], idx);
						} else {
							this.lastNext(idx);
						}
					}
				}
			},
			lastNext(idx) {
				let row = this.details[idx + 1];
				if (!row) {
					this.addItem(idx + 1);
				}
				//摘要自动带入下一行（下一行无摘要时），减少重复录入；用户直接输入即可覆盖
				let nextRow = this.details[idx + 1];
				let curSummary = this.details[idx] && this.details[idx].data.summary;
				if (curSummary && nextRow && !nextRow.data.summary) {
					this.$set(nextRow.data, 'summary', curSummary);
					this.$nextTick(() => {
						let ta = jQuery(`textarea#zy${idx + 1}`);
						if (ta.length) {
							ta.val(curSummary);
						}
					});
				}
				this.doEdit(this.details[idx + 1], 'zy', idx + 1);
			},
			calculateBalance(subjectId) {
				if (subjectId) {
					let balance = this.initBalanceList[subjectId] || 0;
					let items = this.voucherItems.filter(val => val.subjectId === subjectId);
					items.forEach(val => {
						if (val.direction === "借") {
							if (val.debitAmount) {
								balance += Number(val.debitAmount);
							} else if (val.creditAmount) {
								balance -= Number(val.creditAmount);
							}
						} else {
							if (val.debitAmount) {
								balance -= Number(val.debitAmount);
							} else if (val.creditAmount) {
								balance += Number(val.creditAmount);
							}
						}
					});
					this.$set(this.balanceList, subjectId, FormatNum(balance));
				}
			},
			loadVoucherSelect() {
				let tmp = localStorage.getItem('voucherSelect');
				let tmp2 = localStorage.getItem('summarySelect');
				if (tmp) {
					this.voucherSelect = JSON.parse(tmp);
				}
				if (tmp2) {
					this.summarySelect = JSON.parse(tmp2);
				}

				this.$api.setting.subject.voucherSelect().then(({data}) => {
					this.voucherSelect = data;
					localStorage.setItem("voucherSelect", JSON.stringify(data));
				});

				this.$api.voucher.summary().then(({data}) => {
					let newData = data.map(val => {
						return {
							name: val,
							mnemonicCode: ToPy(val)
						}
					});
					this.summarySelect = newData;
					localStorage.setItem("summarySelect", JSON.stringify(newData));
					this.loadSummaryTemplates();
				});
			},
			openSummaryModal() {
				this.summaryModal.show = true;
				this.summaryModal.checkedRows = [];
			},
			loadSummaryTemplates() {
				this.$api.voucher.summaryTemplate.list().then(({data}) => {
					this.summaryTemplates = data || [];
					let exist = this.summarySelect.map(s => s.name);
					let merged = this.summaryTemplates.filter(t => !exist.includes(t.content)).map(t => ({
						name: t.content,
						mnemonicCode: ToPy(t.content)
					}));
					if (merged.length) {
						this.summarySelect = merged.concat(this.summarySelect);
					}
				});
			},
			addSummaryTemplate() {
				let content = (this.summaryModal.newContent || '').trim();
				if (!content) {
					this.$Message('请输入摘要');
					return;
				}
				this.$api.voucher.summaryTemplate.save({content}).then(() => {
					this.summaryModal.newContent = '';
					this.loadSummaryTemplates();
					this.$Message('保存成功');
				});
			},
			removeSummaryTemplate(t) {
				this.$Confirm('确定要删除此摘要吗?').then(() => {
					this.$api.voucher.summaryTemplate.delete(t.id).then(() => {
						this.loadSummaryTemplates();
						this.$Message('删除成功');
					});
				});
			},
			fillSummary(mode) {
				let text = (this.summaryModal.fillText || '').trim();
				if (!text) {
					this.$Message('请输入摘要内容');
					return;
				}
				let count = 0;
				this.details.forEach((d, idx) => {
					let hasContent = d.data.subjectId || d.data.debitAmount || d.data.creditAmount || d.data.summary;
					if (!hasContent) {
						return;
					}
					if (mode === 'blank' && d.data.summary) {
						return;
					}
					if (mode === 'checked' && this.summaryModal.checkedRows.indexOf(idx) === -1) {
						return;
					}
					this.$set(d.data, 'summary', text);
					count++;
				});
				if (count) {
					this.$Message(`已录入${count}行`);
					this.summaryModal.show = false;
				} else {
					this.$Message('没有可录入的行');
				}
			},
			chooseSummary(d, summary, idx) {
				this.$set(d.data, 'summary', summary);
				jQuery(`textarea#zy${idx}`).val(this.currentEdit.row.data.summary);
				this.$refs.zyDropdown[idx].hide();
			},
			chooseSubject(d, subject, idx) {
				if (d.data.subjectId !== subject.id) {
					this.$set(d, 'data', {
						'subjectName': subject.code + "-" + subject.name,
						'subjectId': subject.id,
						'subjectCode': subject.code,
						'unit': subject.unit,
						'direction': subject.balanceDirection,
						'summary': d.data.summary,
						'creditAmount': d.data.creditAmount,
						'debitAmount': d.data.debitAmount,
						'subject': subject
					});
					this.loadSubjectBalance(d.data, subject.id);
				}
				//判断是否有辅助项目
				if (subject.auxiliaryAccounting) {
					this.auxiliaryAccounting[idx] = JSON.parse(subject.auxiliaryAccounting);
					this.loadAuxiliaryAccountingData(idx, subject);
					//开启辅助项输入
					this.$nextTick(() => {
						this.$set(this.details[idx], 'auxiliary', true);
						this.$set(this.currentEdit, 'auxiliary', true);
					});
					jQuery(`textarea#km${idx}`).val(this.currentEdit.row.data.subjectName);
				} else {
					this.endEdit(d, 'km', idx, true);
				}
			},
			loadSubjectBalance(d, subjectId) {
				if (!this.balanceList[subjectId]) {
					this.$api.setting.subject.balance({subjectId: subjectId}).then(({data}) => {
						this.$set(this.balanceList, subjectId, data);
						this.initBalanceList[subjectId] = data;
						this.$set(d, 'balance', data);
					})
				} else {
					this.$set(d, 'balance', this.balanceList[subjectId]);
				}
			},
			clear() {
				this.details = [{zyEdit: false, kmEdit: false, jfEdit: false, dfEdit: false, auxiliary: false, data: {summary: ''}}, {zyEdit: false, kmEdit: false, jfEdit: false, dfEdit: false, auxiliary: false, data: {summary: ''}}, {zyEdit: false, kmEdit: false, jfEdit: false, dfEdit: false, auxiliary: false, data: {summary: ''}}, {zyEdit: false, kmEdit: false, jfEdit: false, dfEdit: false, auxiliary: false, data: {summary: ''}}];
				this.balanceList = {};
			},
			loadAuxiliaryAccountingData(idx, subject) {
				if (!this.auxiliaryAccountingData[subject.id]) {
					this.$api.setting.accountingCategoryDetails.loadAuxiliaryAccountingData(this.auxiliaryAccounting[idx]).then(({data}) => {
						this.$set(this.auxiliaryAccountingData, subject.id, data);
					});
				}
			},
			fillAuxiliary(row, auxiliaryData, idx) {
				let title = "", rowData = row.data;
				Object.keys(auxiliaryData).forEach(val => {
					if (rowData[val]) {
						title += '_' + rowData[val].code + "_" + rowData[val].name;
					}
				});
				this.endEdit(row, 'km', idx, true);
				this.$nextTick(() => {
					this.$set(rowData, "auxiliaryTitle", title);
				});
			},
			showInput(e) {
				let target = jQuery(e.target);
				target.hide();
				target.next().show().focus().select();
			},
			fcmBlur(e, row) {
			let target = jQuery(e.target);
			target.hide();
			target.prev().show();
			let orig = Number(target.val());
			if (isNaN(orig) || !orig) {
				return;
			}
			let amount = FormatNum(orig * Number(this.exchangeRate || 1));
			if (row.direction === '贷') {
				this.$set(row, "creditAmount", amount);
				this.$set(row, "debitAmount", "");
			} else {
				this.$set(row, "debitAmount", amount);
				this.$set(row, "creditAmount", "");
			}
			this.calculateBalance(row.subjectId);
		},
		hideInput(e, row) {
				let target = jQuery(e.target);
				target.hide();
				target.prev().show();
				let inputs = target.closest('.num').find('.numInput');
				switch (row.direction) {
					case '借':
						this.$set(row, "debitAmount", FormatNum(Number(inputs[0].value) * Number(inputs[1].value)));
						this.$set(row, "creditAmount", "");
						break;
					case '贷':
						this.$set(row, "creditAmount", FormatNum(Number(inputs[0].value) * Number(inputs[1].value)));
						this.$set(row, "debitAmount", "");
						break;
				}
			},
			initValue(voucherItems) {
				this.details = [{zyEdit: false, kmEdit: false, jfEdit: false, dfEdit: false, auxiliary: false, data: {summary: ''}}, {zyEdit: false, kmEdit: false, jfEdit: false, dfEdit: false, auxiliary: false, data: {summary: ''}}, {zyEdit: false, kmEdit: false, jfEdit: false, dfEdit: false, auxiliary: false, data: {summary: ''}}, {zyEdit: false, kmEdit: false, jfEdit: false, dfEdit: false, auxiliary: false, data: {summary: ''}}];
				voucherItems.forEach((item, idx) => {
					item.subjectName = item.subjectName;
					item.auxiliaryTitle = item.auxiliaryTitle;

					if (item.subject) {
						item.direction = item.subject.balanceDirection;
						item.unit = item.subject.unit;
						if (item.subject.auxiliaryAccounting) {
							this.auxiliaryAccounting[idx] = JSON.parse(item.subject.auxiliaryAccounting);
							this.loadAuxiliaryAccountingData(idx, item.subject);
						}
					}

					if (item.auxiliary) {
						item.auxiliary.forEach(a => {
							item[a.accountingCategoryId] = a.accountingCategoryDetails;
						});
						delete item.auxiliary;
					}
					this.$set(this.details, idx, Object.assign({}, detail, {data: item}));
				});
			},
			bindEnterTabKeydownEvt() {
				let that = this;
				jQuery(".trDetails").off("keyup", ".edit");
				jQuery(".trDetails").off("keydown", ".edit");
				jQuery(".trDetails").off("blur", ".jf,.df");

				jQuery(".trDetails").on("blur", ".jf,.df", (e) => {
					let {type, index} = jQuery(e.target).closest('.edit').data();
					this.endEdit(that.details[index], type, index, false);
				});

				jQuery(".trDetails").on("keyup", ".edit", function (e) {
					let {type, index} = jQuery(e.target).closest('.edit').data();
					//贷方等于号输入处理
					if ((e.keyCode === 187 || e.code === "Equal" || e.code === "NumpadEqual" || e.key === "=") && (type === 'jf' || type === 'df')) {
						e.preventDefault();
						let details = Array.from(that.details);
						let totalCredit = 0, totalDebit = 0;
						details.forEach((value, i) => {
							if (index !== i) {
								let creditAmount = Number(value.data.creditAmount), debitAmount = Number(value.data.debitAmount);
								if (!isNaN(creditAmount)) {
									totalCredit += creditAmount;
								}
								if (!isNaN(debitAmount)) {
									totalDebit += debitAmount;
								}
							}
						});

						if (type === 'jf' && totalCredit !== 0) {
							let val = FormatNum(totalCredit - totalDebit);
							details[index].data.debitAmount = val;
							details[index].data.creditAmount = 0;
							e.target.value = val;
						} else if (type === 'df' && totalDebit !== 0) {
							let val = FormatNum(totalDebit - totalCredit);
							details[index].data.creditAmount = val;
							details[index].data.debitAmount = 0;
							e.target.value = val;
						}

						that.$set(that, 'details', details);
						return false;
					}
				});

				jQuery(".trDetails").on("keydown", ".edit", function (e) {
					let {type, index} = jQuery(e.target).closest('.edit').data();
					if (e.keyCode === 32 && (type === 'jf' || type === 'df')) {
						e.preventDefault();
						let d = that.details[index].data;
						let v = type === 'jf' ? d.debitAmount : d.creditAmount;
						if (v) {
							if (type === 'jf') {
								that.$set(d, 'creditAmount', v);
								that.$set(d, 'debitAmount', '');
							} else {
								that.$set(d, 'debitAmount', v);
								that.$set(d, 'creditAmount', '');
							}
							e.target.value = '';
						}
						return false;
					}
					if (e.keyCode === 13 || e.keyCode === 9) {
						e.preventDefault();
						if (type === 'km') {
							jQuery('li.subjects-item-select', `#subjects${index}`).click();
							return;
						}
						if (type === 'zy') {
							let select = jQuery(`.summary-item-select`, `#summary${index}`);
							if (select.length) {
								that.$set(that.details[index].data, 'summary', select.text());
							}
						}
						that.endEdit(that.details[index], type, index, true);
						return false;
					}

					if (e.keyCode === 38 || e.keyCode === 40) {
						e.preventDefault();
						if (type === 'km' || type === 'zy') {
							let idPre = type === 'km' ? "subjects" : "summary";
							let subjects = jQuery(`#${idPre}${index}`);
							let select = jQuery(`.${idPre}-item-select`, subjects);

							if (!select.length) {
								subjects.children().first().addClass(`${idPre}-item-select`);
								return false;
							}

							let next = select.prev('li');
							if (e.keyCode === 40) {
								next = select.next('li');
							}

							if (next.length) {
								next.addClass(`${idPre}-item-select`);
								select.removeClass(`${idPre}-item-select`);
								let i = next.data('index');
								if (i > 7) {
									let top = subjects.parent().scrollTop();
									subjects.parent().scrollTop(top + 22)
								}
							}
						}
						return false;
					}
				});
			},
			calculationOfTotal() {
				let jfTotal = 0, dfTotal = 0, budgetJf = 0, budgetDf = 0, hasBudget = false;
				this.details.forEach(value => {
					let debit, credit;
					if ((debit = Number(value.data.debitAmount))) {
						jfTotal += debit;
					}
					if ((credit = Number(value.data.creditAmount))) {
						dfTotal += credit;
					}
					//政府会计平行记账：按科目类别累计预算区金额
					let subject = value.data.subject;
					if (!subject && value.data.subjectId) {
						subject = this.voucherSelect.find(s => s.id === value.data.subjectId);
					}
					if (subject && BUDGET_TYPES.indexOf(subject.type) !== -1) {
						hasBudget = true;
						if (debit) {
							budgetJf += debit;
						}
						if (credit) {
							budgetDf += credit;
						}
					}
				});

				this.jfTotal = FormatNum(jfTotal);
				this.dfTotal = FormatNum(dfTotal);
				this.budgetJfTotal = FormatNum(budgetJf);
				this.budgetDfTotal = FormatNum(budgetDf);
				this.hasBudgetEntry = hasBudget;
			}
		},
		filters: {
			formatMoney: function (value) {
				if (Number(value)) {
					let sp = (Math.abs(FormatNum(value)) + "").split(".");
					if (!sp[1]) {
						return sp[0] + "00"
					} else if (sp[1].length < 2) {
						return sp[0] + sp[1] + "0"
					}
					return sp[0] + sp[1];
				}
				return '';
			},
			fixNum(value) {
				return Number(value) ? FormatNum(value) : '';
			}
		},
		watch: {
			details: {
				deep: true,
				handler() {
					this.calculationOfTotal();
					this.$emit("input", {
						voucherItems: this.voucherItems,
						jfTotal: this.jfTotal || null,
						dfTotal: this.dfTotal || null,
						budgetJfTotal: this.budgetJfTotal || null,
						budgetDfTotal: this.budgetDfTotal || null,
						hasBudgetEntry: this.hasBudgetEntry
					});
				}
			}
		},
		mounted() {
			let that = this;
			this.$nextTick(() => {
				jQuery('table.body').on("mouseover", 'tr.trDetails:not(.total)', function () {
					that.hoverIdx = jQuery(this).data('idx');
					let offset = jQuery(this).offset();
					let offsetParent = jQuery(this).offsetParent().offset();

					jQuery('i.fa-plus-circle').css({
						left: offset.left - offsetParent.left - 14,
						top: offset.top - offsetParent.top + 25,
						display: 'inline-block'
					}).show();
					jQuery('i.fa-times-circle').css({
						left: offset.left - offsetParent.left + 960,
						top: offset.top - offsetParent.top + 25,
						display: 'inline-block'
					}).show();
				}).on("mouseleave", 'tr.trDetails', function () {
					jQuery("i.action[class!='show']").hide();
				});

				jQuery('i.action').hover(function () {
					jQuery(this).addClass('show').css({display: 'inline-block'});
				}, function () {
					jQuery(this).removeClass('show').hide();
				});

				jQuery("#app").on("click.voucherTable", (e) => {
					if (!jQuery(e.target).hasClass('display')
						&& !jQuery(e.target).hasClass('subjects-item')
						&& !jQuery(e.target).closest('.auxiliary').length
						&& !jQuery(e.target).closest('.tdInput').length
						&& !jQuery(e.target).closest('.h-dropdown').length
						&& this.currentEdit) {
						this.endEdit(this.currentEdit.row, this.currentEdit.type, this.currentEdit.idx)
					}
				});

				this.bindEnterTabKeydownEvt();
			});

			this.loadVoucherSelect();
		},
		beforeDestroy() {
			jQuery("#app").off("click.voucherTable");
		}
	}
</script>

<style lang="less">
	.voucher-table {
		position: relative;
		font-size: 12px;
		width: 1000px;
		padding: 10px 20px;

		.tdLast {
			border-right: 1px solid #dadada;
		}

		.header {
			width: 960px;
			text-align: center;
			line-height: 30px;
		}

		table tbody tr td {
			border-left: 1px solid #dadada;
			border-top: 1px solid #dadada;
			border-bottom: 1px solid #dadada;
			padding: 0;
			border-spacing: 0;
		}

		.moneyUint {
			border-top: 1px solid #dadada;
			height: 30px;
			background-image: url(../assets/moneyUint.png);
			width: 221px;

			span {
				float: left;
				display: inline;
				width: 19px;
				height: 100%;
				margin-right: 1px;
				background-color: #fff;
				text-align: center;
				font-size: 12px;
			}

			.last {
				margin-right: 0;
			}
		}

		.body {
			width: 960px;
			text-align: center;

			.numInput {
				outline: none;
			}

			td {
				vertical-align: top;
			}

			.trDetails {
				width: 959px;

				.spTotal {
					width: 250px;
					text-align: left;
					vertical-align: middle;
					font-weight: bold;
				}

				.h-icon-error {
					right: 55px;
					top: 20px;
				}

				.display {
					height: 60px;
					font-weight: bold;
					font-size: 13px;
					text-align: left;
					padding: 2px;
					line-height: 17px;
				}

				.tdZhaoyao {
					width: 207px;
				}

				.tdKemu {
					width: 307px;
					position: relative;

					.yue {
						position: absolute;
						bottom: 2px;
						left: 2px;
						z-index: 2;
						font-weight: bold;
					}

					.num {
					position: absolute;
					bottom: 17px;
					right: 5px;
					line-height: 23px;
					font-weight: normal;
					z-index: 2;
				}

				.fcm {
					position: absolute;
					bottom: 2px;
					left: 120px;
					line-height: 20px;
					font-weight: normal;
					z-index: 3;

					.fcmInput {
						width: 80px;
						outline: none;
					}
				}
				}

				.tdJieFang, .tdDaiFang {
					width: 221px;
				}

				&.zone-total .zone-info {
					text-align: left;
					font-size: 12px;
					line-height: 24px;
					color: #666;

					.zone-sep {
						margin: 0 12px;
						color: #ccc;
					}

					.red-color {
						font-weight: bold;
					}
				}

				.displayMoney {
					font-weight: bold;
					font-size: 14px;
					letter-spacing: 11px;
					overflow: hidden;
					text-align: right;
					font-family: 'tahoma', serif;
					background-image: url(../assets/moneyUint.png);
					line-height: 60px;
					padding: 0;

					span {
						position: relative;
						right: -5px;
					}
				}

				.h-autocomplete-show {
					border: none;
					border-radius: 0;
				}

				.h-input {
					border: none;
					border-radius: 0;
					height: 60px !important;
					resize: none !important;
					width: 100% !important;
				}

				textarea.h-input {
					height: 60px !important;
				}

				.h-dropdowncustom-show-content {
					width: 100% !important;
				}
			}

			tbody:first-child td {
				border-top: 0 !important;
			}
		}

		.action {
			position: absolute;
			font-size: 16px;
			cursor: pointer;
			display: none;

			&:hover {
				color: @primary-color;
			}
		}

		.h-numberinput-show {
			border-radius: 0;

			&.focusing {
				border: 1px solid #44b449;
				box-shadow: none;
			}

			.h-input {
				font-size: 16px;
				font-weight: bold;
			}
		}
	}

	.subjects, .summary {
		li {
			padding: 2px 10px;
			cursor: pointer;
			font-size: 12px;
			white-space: nowrap;

			&:hover {
				background: @primary-color;
				color: @white-color;
			}
		}

		&-item-select {
			background: @primary-color;
			color: @white-color;
		}
	}

	.hoverNum {
		text-align: right;
		padding: 0 10px;
		font-size: 26px;
		font-weight: bold;
		height: 60px;
		line-height: 60px;
	}

	.summary-manage {
		float: right;
		cursor: pointer;
		font-size: 13px;
		line-height: 30px;
		margin-right: 4px;
		color: #666;

		&:hover {
			color: @primary-color;
		}
	}

	.summary-modal {
		width: 560px;

		.block {
			margin-bottom: 10px;
		}

		.block-title {
			font-weight: bold;
			margin-bottom: 8px;
		}

		.row-checks {
			margin-top: 8px;
			max-height: 120px;
			overflow-y: auto;

			label {
				margin-right: 12px;
				cursor: pointer;
				font-weight: normal;
			}
		}

		.tpl-list {
			margin-top: 8px;
			max-height: 200px;
			overflow-y: auto;
			border: 1px solid #eee;

			li {
				display: flex;
				justify-content: space-between;
				align-items: center;
				padding: 4px 10px;
				border-bottom: 1px solid #f3f3f3;

				.tpl-content {
					cursor: pointer;
					flex: 1;

					&:hover {
						color: @primary-color;
					}
				}

				.fa-trash-o {
					cursor: pointer;
					color: #999;

					&:hover {
						color: @red-color;
					}
				}

				&.empty {
					justify-content: center;
					color: #999;
					padding: 12px;
				}
			}
		}
	}
</style>